var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#39A2DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C8 12.4477 8.3078 12 8.6875 12H18.3125C18.6922 12 19 12.4477 19 13C19 13.5523 18.6922 14 18.3125 14H8.6875C8.3078 14 8 13.5523 8 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7722 7.21967C14.0759 7.51256 14.0759 7.98744 13.7722 8.28033L8.87772 13L13.7722 17.7197C14.0759 18.0126 14.0759 18.4874 13.7722 18.7803C13.4685 19.0732 12.976 19.0732 12.6723 18.7803L7.22781 13.5303C6.92406 13.2374 6.92406 12.7626 7.22781 12.4697L12.6723 7.21967C12.976 6.92678 13.4685 6.92678 13.7722 7.21967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2);
export default __webpack_public_path__ + "static/media/back2.b9906e502be4150645f84e21eba677a5.svg";
export { ForwardRef as ReactComponent };